// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"styles_videoPlayer__W_c2x","playIcon":"styles_playIcon__Witml","introVideoContainer":"styles_introVideoContainer__YN4EM"};